import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import jwtDecode from 'jwt-decode';
import { matchPath } from 'react-router';
import { LOCATION_CHANGE, push } from 'react-router-redux';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { hasTokenExpired } from '../../../common';
import { routes } from '../../../constants';
import actions from './actions';

export function* login({ payload: { username, password } }) {
  const authenticateUser = () =>
    new Promise((resolve, reject) =>
      ((cognitoUser) =>
        cognitoUser.authenticateUser(new AuthenticationDetails({
          Username: username,
          Password: password
        }), {
            onSuccess: (result) => resolve({
              idToken: result.getIdToken().getJwtToken()
            }),
            onFailure: reject,
            newPasswordRequired: (attributes) => resolve({
              user: cognitoUser,
              attributes,
              newPasswordRequired: true
            })
          })
      )(new CognitoUser({
        Username: username,
        Pool: new CognitoUserPool({
          UserPoolId: process.env.COGNITO_USER_POOL_ID,
          ClientId: process.env.COGNITO_CLIENT_ID
        })
      }))
    );

  try {
    const {
      user,
      idToken,
      newPasswordRequired,
      attributes
    } = yield call(authenticateUser);

    if (newPasswordRequired) {
      yield put(actions.session.newPasswordRequired(user, attributes));
    } else {
      yield put(actions.session.loginSuccess(idToken));
    }
  } catch (error) {
    yield put(actions.session.loginFailed(error.message));
  }
}

function* loginSuccess() {
  yield put(push(routes.adminPortal.root));
}

function* newPasswordRequired() {
  yield put(push(routes.newPassword));
}

function* submitNewPassword({ payload: { newPassword, attributes } }) {
  const user = yield select(({ session: { user } }) => user);

  const completeNewPasswordChallenge = () =>
    new Promise((resolve, reject) =>
      user.completeNewPasswordChallenge(newPassword, attributes, {
        onSuccess: (result) => resolve({
          idToken: result.getIdToken().getJwtToken()
        }),
        onFailure: reject
      }));

  try {
    const { idToken } = yield call(completeNewPasswordChallenge);
    yield put(actions.session.loginSuccess(idToken));
  } catch (error) {
    yield put(actions.session.loginFailed(error.message));
  }
}

function* checkAuthorisation({ payload: { pathname } }) {
  const idToken = yield select(({ session: { idToken } }) => idToken);

  const tokenExpired = idToken && hasTokenExpired(jwtDecode(idToken));

  if (tokenExpired) {
    yield put(actions.session.removeIdToken);
  }

  const match = matchPath(pathname, { path: routes.adminPortal.root });

  if ((!idToken || tokenExpired) && match) {
    yield put(push(routes.login));
  }
}

function* sagas() {
  yield all([
    takeLatest(actions.session.login().type, login),
    takeLatest(actions.session.loginSuccess().type, loginSuccess),
    takeLatest(actions.session.newPasswordRequired().type, newPasswordRequired),
    takeLatest(actions.session.submitNewPassword().type, submitNewPassword),
    takeLatest(actions.session.unauthorised().type, checkAuthorisation),
    takeLatest(LOCATION_CHANGE, checkAuthorisation)
  ]);
}

export default sagas;



// WEBPACK FOOTER //
// ./src/state/modules/session/sagas.js